import { useEffect, useState } from 'react';

export interface UsePromoBarRotationOptions {
  itemCount: number;
  refreshTime?: number;
  fadeTime?: number;
  enabled?: boolean;
}

export interface UsePromoBarRotationReturn {
  currentIndex: number;
  fadeDuration: number;
}

export const usePromoBarRotation = ({
  itemCount,
  refreshTime = 6000,
  fadeTime = 500,
  enabled = true,
}: UsePromoBarRotationOptions): UsePromoBarRotationReturn => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!enabled || itemCount <= 1) return;

    // Cycle timing: change index after refreshTime (display duration)
    // Motion with AnimatePresence mode="wait" will handle:
    // 1. Exit animation (fade out) - fadeTime duration
    // 2. Enter animation (fade in) - fadeTime duration
    // Total cycle: refreshTime (display) + fadeTime (exit) + fadeTime (enter)
    // The index change triggers the transition, Motion handles the rest
    const tid = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % itemCount);
    }, refreshTime);

    return () => clearTimeout(tid);
  }, [currentIndex, itemCount, refreshTime, fadeTime, enabled]);

  return {
    currentIndex,
    fadeDuration: fadeTime,
  };
};
